export default {
  get(key) {
    let item = localStorage.getItem(`mbk777.${key}`);
    try {
      return item && JSON.parse(item);
    } catch (err) {
      return null;
    }
  },
  set(key, value) {
    localStorage.setItem(`mbk777.${key}`, JSON.stringify(value));
  },
  remove(key) {
    localStorage.removeItem(`mbk777.${key}`);
  }
}



// WEBPACK FOOTER //
// ./_common/services/localdata.service.js